import type * as Blockly from 'blockly/core';
import { expr, registerSetupCode, resolveAnalogPin } from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import { markPercentUsed } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/helper/analog_helper';

export function register(gen: any): void {
    gen.forBlock['flex'] = function (block: Blockly.Block): [string, number] {
        const { pin, config } = resolveAnalogPin(block);
        const readMode = block.getFieldValue('READ_MODE');

        registerSetupCode(pin, `  pinMode(${pin}, INPUT);\n`);

        if (readMode === 'PERCENT') {
            markPercentUsed();
            return expr(`_sbeGetPercent(${pin}, ${config.analogRes})`);
        }

        return expr(`analogRead(${pin})`);
    };
}
